import { TableRow } from "@mui/material";
import styled from "styled-components";
import { COLORS } from "../../../constants/colors";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { ShowcaseTableRowProps } from "../../../constants/types";
import { getStatusInfo } from "../../../constants/function";
import { useCallback } from "react";

const StyledTableRow = styled(TableRow)<any>(() => ({
  [`&`]: {
    cursor: "pointer",
    background: "white",
  },
  [`&.disconnect`]: {
    background: COLORS.lightGray,
  },
  [`&.high-temp`]: {
    background: COLORS.lightOrange2,
  },
  [`&.low-battery`]: {
    background: COLORS.purple2,
  },
  [`&:hover`]: {
    background: COLORS.lightGray3,
  },
  [`&:nth-of-type(even)`]: {
    padding: "0.65%",
    fontSize: "1em",
    fontWeight: 600,
    color: COLORS.fontColor,
  },
}));

const ShowcaseTableRow = (props: ShowcaseTableRowProps) => {
  const onClick = useCallback(() => {
    window.open(props.data.link, "_blank");
  }, []);
  return (
    <StyledTableRow
      onClick={onClick}
      className={getStatusInfo(props.data.status).name}
    >
      <PublicStyledTableCell>{props.data.storeName}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.showcase}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.id}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.temperature}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.battery}</PublicStyledTableCell>
      <PublicStyledTableCell>
        {props.data.referenceTemperature}
      </PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.lastDate}</PublicStyledTableCell>
      <PublicStyledTableCell>{props.data.note}</PublicStyledTableCell>
    </StyledTableRow>
  );
};

export default ShowcaseTableRow;
